import {useState} from "react";
import {Box, IconButton, Typography, Modal} from "@mui/material";
import {Help} from "@mui/icons-material";

const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 400,
  backgroundColor: '#FFF',
  borderTop: 10,
  borderColor: '#047857',
  boxShadow: 24,
  borderRadius: 2,
  p: 4
}

function ButtonToggleText({description = null}){
  const [showDescription, setShowDescription] = useState(false)

  const setOpen = () => setShowDescription(true)
  const setClose = () => setShowDescription(false)


  return (
    <>
      {description !== null ?
      <>
        <IconButton size="small" onClick={setOpen} aria-label="Ver descrição">
          <Help sx={{color: "#D1FAE5",  backgroundColor: "#047857", borderRadius: "50px"}}/>
        </IconButton>

        <Modal open={showDescription} onClose={setClose}>
          <Box sx={style}>
            <div className="flex items-center justify-center mb-10">
              <Help className="bg-emerald-200 text-emerald-700 rounded-full" sx={{width: 50, height: 50}}/>
            </div>
            <Typography variant="body2" className="font-semibold text-gray-600">
              {description}
            </Typography>
          </Box>
        </Modal>

      </>
        :

        <>
        </>
      }
    </>
  )
}

export default ButtonToggleText